import { Checkbox } from 'components/ideal-core-ui'

const Filters = ({ details, setOrganizationDetails }) => {
  return (
    <div style={{ marginBottom: 30 }}>
      <h5>Opportunities Board Additional Filters</h5>
      <p>
        The Opportunities Board (click on Opportunities on the top navigation) already features a
        Users filter and a Date Range filter. You can select additional filters for the board from
        the list below. These filters, when applied, will help narrow down the list of opportunity
        cards on the board.
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasContractorAwarded}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasContractorAwarded = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Contractor Awarded
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasTeams}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasTeams = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Teams
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasContractType}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasContractType = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Contract Type
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasPriority}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasPriority = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Opportunity Priority
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasCategory}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasCategory = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Opportunity Category
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasSize}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasSize = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Opportunity Size
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasSource}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasSource = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Opportunity Source
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasScope}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasScope = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Scope
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasWorkType}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasWorkType = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Work Type
      </p>
      <Checkbox
        size="md"
        isChecked={details.dealSettings?.filters?.hasGeographicalArea}
        triggerCheckbox={value => {
          setOrganizationDetails(state => {
            state.dealSettings.filters.hasGeographicalArea = value.target.checked
          })
        }}
      />
      <p
        style={{ margin: '0 30px 0 5px', display: 'inline-block', position: 'relative', bottom: 3 }}
      >
        Geographical Area
      </p>
    </div>
  )
}

export default Filters
